import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminNav = () => {
  const navigate = useNavigate();
  const [showProfile, setShowProfile] = useState(false);

  const handleLogout = () => {
    // Add logout logic here
    navigate('/login');
  };

  const styles = {
    navbar: {
      height: '70px',
      background: '#fff',
      borderBottom: '1px solid #e0e0e0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 2rem',
      position: 'sticky',
      top: 0,
      zIndex: 999,
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    },
    leftSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '1.5rem',
    },
    pageTitle: {
      fontSize: '1.5rem',
      fontWeight: 600,
      color: '#333',
      margin: 0,
    },
    searchBar: {
      display: 'flex',
      alignItems: 'center',
      background: '#f5f5f5',
      borderRadius: '8px',
      padding: '0.5rem 1rem',
      gap: '0.5rem',
      width: '300px',
    },
    searchInput: {
      border: 'none',
      background: 'transparent',
      outline: 'none',
      fontSize: '0.95rem',
      width: '100%',
      color: '#333',
    },
    rightSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
    },
    profileBtn: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.8rem',
      background: 'transparent',
      border: '2px solid #e0e0e0',
      borderRadius: '10px',
      padding: '0.5rem 1rem',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
    avatar: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '1.2rem',
      fontWeight: 600,
    },
    profileInfo: {
      textAlign: 'left',
    },
    profileName: {
      fontSize: '0.95rem',
      fontWeight: 600,
      color: '#333',
      margin: 0,
    },
    profileRole: {
      fontSize: '0.75rem',
      color: '#666',
      margin: 0,
    },
    dropdown: {
      position: 'absolute',
      top: 'calc(100% + 10px)',
      right: 0,
      background: '#fff',
      borderRadius: '10px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
      minWidth: '200px',
      overflow: 'hidden',
      zIndex: 1000,
    },
    dropdownItem: {
      padding: '0.8rem 1.2rem',
      cursor: 'pointer',
      transition: 'background 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      gap: '0.8rem',
      fontSize: '0.9rem',
      color: '#333',
      background: 'transparent',
      border: 'none',
      width: '100%',
      textAlign: 'left',
    },
  };

  return (
    <nav style={styles.navbar}>
      {/* Left Section */}
      <div style={styles.leftSection}>
        <h1 style={styles.pageTitle}>Dashboard</h1>
        
        <div style={styles.searchBar}>
          <span>🔍</span>
          <input
            type="text"
            placeholder="Search bookings, guests, rooms..."
            style={styles.searchInput}
          />
        </div>
      </div>

      {/* Right Section */}
      <div style={styles.rightSection}>
        {/* Profile Dropdown */}
        <div style={{ position: 'relative' }}>
          <button
            style={styles.profileBtn}
            onClick={() => setShowProfile(!showProfile)}
            onMouseOver={(e) => {
              e.currentTarget.style.borderColor = '#2c5aa0';
              e.currentTarget.style.background = '#f8f9fa';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.borderColor = '#e0e0e0';
              e.currentTarget.style.background = 'transparent';
            }}
          >
            <div style={styles.avatar}>A</div>
            <div style={styles.profileInfo}>
              <p style={styles.profileName}>Admin User</p>
              <p style={styles.profileRole}>Administrator</p>
            </div>
            <span style={{ fontSize: '0.8rem' }}>▼</span>
          </button>

          {showProfile && (
            <div style={styles.dropdown}>
              <button
                style={styles.dropdownItem}
                onMouseOver={(e) => {
                  e.currentTarget.style.background = '#fff5f5';
                  e.currentTarget.style.color = '#ff6b6b';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = '#333';
                }}
                onClick={handleLogout}
              >
                <span>🚪</span> Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default AdminNav;